// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-message[data-v-c125253e] {
  min-height: 40px;
}
.audio-active[data-v-c125253e] {
  width: 100%;
}
.audio-active .audio-message-info[data-v-c125253e] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}
.audio-active .audio-message-info .voice-message[data-v-c125253e] {
  color: var(--custom-textarea-color);
  padding-right: 20px;
  min-width: 170px;
}
.audio-active .audio-message-info #audio-spectrum[data-v-c125253e] {
  height: 4rem;
  flex-grow: 2;
  width: -webkit-fill-available;
  max-width: 440px;
}
.audio-active .audio-message-info .sending-progress[data-v-c125253e] {
  position: relative;
  height: 4rem;
  flex-grow: 2;
  width: -webkit-fill-available;
  max-width: 440px;
}
.audio-active .audio-message-info .sending-progress .sending-progress-bar[data-v-c125253e] {
  position: absolute;
  display: flex;
  align-items: center;
  background-color: #00aafb59;
  height: 98%;
  max-width: 100%;
}
.audio-active .audio-message-info .sending-progress .sending-progress-bar .progress-label[data-v-c125253e] {
  opacity: 0.5;
  padding: 0 1rem;
}
.audio-active .audio-message-info .actions[data-v-c125253e] {
  display: flex;
  justify-content: space-between;
}
.audio-active .recording-time[data-v-c125253e] {
  display: flex;
  align-items: center;
  width: 50px;
  overflow: visible;
}
.audio-active .recording-time .recording-circle[data-v-c125253e] {
  color: #1a4cf3;
  opacity: 1;
  animation: blink-c125253e 1s linear infinite;
  font-size: 8px;
  margin-right: 5px;
  padding-top: 1px;
}
@keyframes blink-c125253e {
30% {
    opacity: .3;
}
60% {
    opacity: .6;
}
100% {
    opacity: 1;
}
}
.audio-active .recording-btns[data-v-c125253e] {
  margin: 0 10px;
}
.audio-active .recording-btns .fa-times-circle[data-v-c125253e] {
  color: tomato !important;
  font-size: 25px;
}
.audio-active .recording-btns .fa-check-circle[data-v-c125253e] {
  color: #00aafb !important;
  font-size: 25px;
}
.audio-active > .buttons[data-v-c125253e] {
  margin: auto 5px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/AudioMsgRecorder.vue"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,UAAU;EACV,4CAA4C;EAC5C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".audio-message[data-v-c125253e] {\n  min-height: 40px;\n}\n.audio-active[data-v-c125253e] {\n  width: 100%;\n}\n.audio-active .audio-message-info[data-v-c125253e] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n}\n.audio-active .audio-message-info .voice-message[data-v-c125253e] {\n  color: var(--custom-textarea-color);\n  padding-right: 20px;\n  min-width: 170px;\n}\n.audio-active .audio-message-info #audio-spectrum[data-v-c125253e] {\n  height: 4rem;\n  flex-grow: 2;\n  width: -webkit-fill-available;\n  max-width: 440px;\n}\n.audio-active .audio-message-info .sending-progress[data-v-c125253e] {\n  position: relative;\n  height: 4rem;\n  flex-grow: 2;\n  width: -webkit-fill-available;\n  max-width: 440px;\n}\n.audio-active .audio-message-info .sending-progress .sending-progress-bar[data-v-c125253e] {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  background-color: #00aafb59;\n  height: 98%;\n  max-width: 100%;\n}\n.audio-active .audio-message-info .sending-progress .sending-progress-bar .progress-label[data-v-c125253e] {\n  opacity: 0.5;\n  padding: 0 1rem;\n}\n.audio-active .audio-message-info .actions[data-v-c125253e] {\n  display: flex;\n  justify-content: space-between;\n}\n.audio-active .recording-time[data-v-c125253e] {\n  display: flex;\n  align-items: center;\n  width: 50px;\n  overflow: visible;\n}\n.audio-active .recording-time .recording-circle[data-v-c125253e] {\n  color: #1a4cf3;\n  opacity: 1;\n  animation: blink-c125253e 1s linear infinite;\n  font-size: 8px;\n  margin-right: 5px;\n  padding-top: 1px;\n}\n@keyframes blink-c125253e {\n30% {\n    opacity: .3;\n}\n60% {\n    opacity: .6;\n}\n100% {\n    opacity: 1;\n}\n}\n.audio-active .recording-btns[data-v-c125253e] {\n  margin: 0 10px;\n}\n.audio-active .recording-btns .fa-times-circle[data-v-c125253e] {\n  color: tomato !important;\n  font-size: 25px;\n}\n.audio-active .recording-btns .fa-check-circle[data-v-c125253e] {\n  color: #00aafb !important;\n  font-size: 25px;\n}\n.audio-active > .buttons[data-v-c125253e] {\n  margin: auto 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
